/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFilters = createReactComponent("filters", "IconFilters", [
  ["path", { d: "M12 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", key: "svg-0" }],
  ["path", { d: "M8 11a5 5 0 1 0 3.998 1.997", key: "svg-1" }],
  ["path", { d: "M12.002 19.003a5 5 0 1 0 3.998 -8.003", key: "svg-2" }]
]);

export { IconFilters as default };
//# sourceMappingURL=IconFilters.js.map
